import { useEffect } from "react";
import { NavLink } from "react-router-dom";
import { DropdownItem } from "reactstrap";

import styles from "components/NavMenu/Components/MatchToolsLinks/MatchToolsLinks.module.css";
import useFetch from "Hooks/useFetch";
import useUserContext from "Hooks/useUserContext";

export default function MatchToolsLinks() {
    const { get } = useFetch();
    const [userContext, onSetUserContext] = useUserContext();

    useEffect(() => {
        if (!userContext.isAuthenticated || !userContext.companyId) {
            return;
        }

        let ignore = false;

        getTools();

        async function getTools() {
            const response = await get(`/api/match_tools/for_company`);

            let data;
            try {
                data = await response.json();
            } catch {
                data = response;
            }
            console.log("Get match tools from database response: ", data);

            if (response.ok && !ignore) {
                onSetUserContext({ matchTools: data as ITool[] });
            }
        }

        return () => {
            ignore = true;
        };
    }, [
        get,
        onSetUserContext,
        userContext.isAuthenticated,
        userContext.companyId,
    ]);

    return (
        <>
            {userContext.matchTools?.map((t, i) => (
                <DropdownItem
                    key={t.description ?? i}
                    tag={NavLink}
                    to={`/tools/match_tools/${t.method_name.toLowerCase()}`}
                    className={styles.link}
                >
                    {t.description?.replaceAll("_", " ")}
                </DropdownItem>
            ))}
        </>
    );
}
